import { IArticleTag, IHeroPositionHeroPosition } from '@propertypal/shared/src/types/strapi';
import { ContentHubArticle } from '@propertypal/shared/src/types/strapi/overrides';
import React from 'react';
import ContentHubContentContainer from './ContentHubContentContainer';
import { ContentHubContainer, ContentHubHeaderBg } from './ContentHubPageContainer.style';

export interface ContentHubBreadCrumb {
  title: string | React.ReactNode;
  url?: string;
}

export interface SidebarData {
  tag?: IArticleTag['attributes'] | null;
  prevArticle?: ContentHubArticle | null;
  nextArticle?: ContentHubArticle | null;
  subCategory?: string;
  category?: string;
  articleTitle?: string;
  hideSubscription?: boolean;
}

export interface ContentHubPageContainerProps {
  children?: React.ReactNode;
  breadcrumbs?: (ContentHubBreadCrumb | undefined)[];
  poster?: string;
  tabletPoster?: string;
  mobilePoster?: string;
  showSidebar?: boolean;
  sidebarData?: SidebarData;
  articleHeroPosition?: IHeroPositionHeroPosition | null;
  bg?: string;
}

const ContentHubPageContainer: React.FC<ContentHubPageContainerProps> = ({
  children,
  articleHeroPosition,
  bg,
  ...props
}) => {
  return (
    <ContentHubContainer $bg={bg}>
      <ContentHubHeaderBg
        data-testid="content-hub-poster"
        url={props.poster}
        tabletUrl={props.tabletPoster}
        mobileUrl={props.mobilePoster}
        bgPositionX={articleHeroPosition?.bgPositionX}
        bgPositionY={articleHeroPosition?.bgPositionY}
        tabletBgPositionX={articleHeroPosition?.tabletBgPositionX}
        tabletBgPositionY={articleHeroPosition?.tabletBgPositionY}
        mobileBgPositionX={articleHeroPosition?.mobileBgPositionX}
        mobileBgPositionY={articleHeroPosition?.mobileBgPositionY}
      />
      <ContentHubContentContainer {...props}>{children}</ContentHubContentContainer>
    </ContentHubContainer>
  );
};

export default ContentHubPageContainer;
